import React, { useMemo } from 'react';
import css from './Pages.module.scss';
import classnames from 'classnames';

const Page = ({ metaCurrentPage, pagination, paginationUrlBlank, metaLastPage }) => {
    const pagesArr = useMemo(() => [...Array(metaLastPage).keys()].map((i) => i + 1), [metaLastPage]);
    return pagesArr.map((pageData, pageIndex) => {
        if (
            pagesArr.length > 8 &&
            ((metaCurrentPage > 4 && pageIndex === metaCurrentPage - 3 && metaCurrentPage <= pagesArr.length - 4) ||
                (metaCurrentPage > 4 && metaCurrentPage <= pagesArr.length - 4 && pageIndex === metaCurrentPage + 1) ||
                (metaCurrentPage <= 4 && pageIndex === 5) ||
                (metaCurrentPage > pagesArr.length - 4 && pageIndex === pagesArr.length - 5) ||
                (metaCurrentPage === pagesArr.length - 3 && pageData + 2 === metaCurrentPage)) &&
            pageData + 1 !== metaCurrentPage
        ) {
            return (
                <div key={`${pageIndex}Block`} className={css.paginationNumberBlock}>
                    <p className={css.paginationNumber}> ... </p>
                </div>
            );
        }
        if (
            pagesArr.length <= 8 ||
            (pageIndex <= 3 && metaCurrentPage >= pagesArr.length - 3) ||
            (pageIndex >= pagesArr.length - 4 && metaCurrentPage >= pagesArr.length - 3) ||
            pageIndex >= pagesArr.length - 2 ||
            pageIndex <= 1 ||
            (metaCurrentPage <= 4 && pageIndex <= 4) ||
            (pageIndex >= pagesArr.length - 4 && metaCurrentPage <= 4) ||
            (metaCurrentPage > 4 &&
                metaCurrentPage <= pagesArr.length - 2 &&
                pageIndex >= metaCurrentPage - 2 &&
                pageIndex <= metaCurrentPage) ||
            pageData + 1 === metaCurrentPage
        ) {
            return (
                <div
                    key={`${pageIndex}Block`}
                    className={
                        pageData === metaCurrentPage
                            ? classnames(css.paginationNumberBlock, css.paginationNumberBlockActive)
                            : css.paginationNumberBlock
                    }
                    onClick={() => pageData !== metaCurrentPage && pagination(`${paginationUrlBlank}${pageData}`)}
                >
                    <p
                        className={
                            pageData === metaCurrentPage
                                ? classnames(css.paginationNumber, css.paginationNumberActive)
                                : css.paginationNumber
                        }
                        key={pageIndex}
                    >
                        {pageData}
                    </p>
                </div>
            );
        }
    });
};
export default Page;
